import React from 'react'

const Rooms = () => {
  return (
    <div>Rooms</div>
  )
}

export default Rooms